import type { ProductDTO } from '@common/contracts/server/modules/product/presentation/api/dto';

import { TPoint } from '@/components/product/info-blocks/types';

import type { FetcherAxiosInstance } from '../fetcher';

interface IProductProp {
  productId: string
}

export const createProductApi = (Fetcher: FetcherAxiosInstance) => ({
  fetchProductPromoKits: ({ productId }: IProductProp) => Fetcher(`/product/${productId}/promo-kits`),

  fetchSizeTable: ({ productId }: IProductProp) => Fetcher(`/product/${productId}/size-table`),

  sendRecentlyViewedProduct: (productId: string) => Fetcher.post(`/profiles/viewed-products/${productId}`),

  fetchAvailabilityStores: ({ productId }: IProductProp) => Fetcher(`/product/${productId}/availability/stores`),

  fetchAvailabilityProductsCount: ({ productId }: IProductProp) => Fetcher(`/product/${productId}/availability/products-count`),

  fetchProduct(productId: string): Promise<ProductDTO> {
    return Fetcher.get(`/product/${productId}`);
  },

  fetchPersonalPrice(productId: string) {
    return Fetcher.get(`/products/${productId}/personal-price`);
  },

  async fetchPickupAvailability(skuId: string): Promise<TPoint[]> {
    const points: TPoint[] = await Fetcher.get('/products/availability/pick-up', { params: { skuId } });

    return points;
  },
});
